import React,{Component} from 'react'

class ARExample extends Component{
    render(){
        return(
            <img src="./images/aug_1.png" alt="augmented reality example"/>
        )
    }
}

export default ARExample


// WEBPACK FOOTER //
// ./src/ARExample.js